import { createSelector } from 'reselect';
import { CLIENT_STATE } from './EducationChartReducer';

export const clientId = (state, props) => props.clientId;

export const educationChartReducer = state => state.EducationChartReducer;

export const educationChart = createSelector(
    clientId,
    educationChartReducer,
    (currentClient, reducer) => reducer[currentClient] || CLIENT_STATE,
);

export const isPrint = (state, props) => (
    props.isPrint || educationChart(state, props).isPrint
);

export const hasLoaded = (state, props) => (
    props.loaded || educationChart(state, props).loaded
);

export const isPdf = (state, props) => (
    props.isPdf || educationChart(state, props).isPdf
);

export const goalId = (state, props) => (
    props.goalId || educationChart(state, props).goalId
);
export const currentGoalId = (state, props) => (
  educationChart(state, props).currentGoalId
);
export const fpId = (state, props) => (
    props.fpId || educationChart(state, props).fpId
);

export const goalChartSettings = (state, props) => (
    educationChart(state, props).chartSettings
);

export const goalChartData = (state, props) => (
    props.Data || educationChart(state, props).data
);

export const chartCategories = (state, props) => (
    goalChartData(state, props).Categories
);

export const expensesSeries = (state, props) => (
    goalChartData(state, props).Series.Expenses
);

export const coveredSeries = (state, props) => (
    goalChartData(state, props).Series.Covered
);

export const hasChartData = (state, props) => (
    chartCategories(state, props).length > 0
);

export const dataIsOutdated = (state, props) => {
    const hasCurrentData = hasChartData(state, props);
    const hasGoalId = goalId(state, props).length >= 0;
    const sameGoalId = goalId(state, props) === currentGoalId(state, props);
    return hasGoalId && hasCurrentData && !sameGoalId;
};

export const chartTitle = (state, props) => (
    props.chartTitle || goalChartData(state, props).title
);

export const goalChartPopulated = createSelector(
    goalChartSettings,
    chartCategories,
    expensesSeries,
    coveredSeries,
    isPrint,
    (chartSettings, categories, expenses, covered, isPrintPage) => {
        const seriesWithData = chartSettings.series.map((serie, index) => {
            if (index === 0) {
                return {
                    ...serie,
                    animation: !isPrintPage,
                    color: isPrintPage ? '#e5f8ff' : serie.color,
                    data: [...expenses],
                    pointWidth: expenses.length <= 2 ? 150 : null,
                };
            }

            return {
                ...serie,
                animation: !isPrintPage,
                data: [...covered],
                pointWidth: covered.length <= 2 ? 150 : null,
            };
        });

        return {
            ...chartSettings,
            xAxis: {
                ...chartSettings.xAxis,
                categories,
            },
            series: seriesWithData,
        };
    },
);
